import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatCarouselImage = createCustomElementWrapper('kat-carousel-image', 'KatCarouselImage', {
    'imageFit': 'image-fit',
    'katAriaLabel': 'kat-aria-label',
    'linkHref': 'link-href',
    'linkTarget': 'link-target',
}, {});
